
import {
    defineComponent,
    ref
} from 'vue';

import {
    MutationTypes,
    useStore
} from '../../store';

export default defineComponent({

    setup() {
        const store = useStore();
        const state = ref(store.state);

        const allTechnologies = new Set < string > ();
        for (const project of store.state.projects) {
            project.technologies.forEach(item => allTechnologies.add(item))
        }
        const technologies = Array.from(allTechnologies).sort();
        store.commit(MutationTypes.SET_TECHNOLOGY, technologies);

        return {
            state,
            store,
            technologies
        };

    },
    methods: {
        techClick: function (technology: string) {
            const index = this.state.selectedTechnologies.indexOf(technology);
            if (index === -1) {
                this.store.commit(MutationTypes.SELECT_TECHNOLOGY, technology)
            } else {
                this.store.commit(MutationTypes.DESELECT_TECHNOLOGY, technology)
            }
        },
        colapseAll: function () {
            this.store.commit(MutationTypes.SET_TECHNOLOGY, []);
        },
        expandAll: function () {
            this.store.commit(MutationTypes.SET_TECHNOLOGY, this.technologies);
        }
    }
});
